import { FC } from 'react';

import { TutorialStepData } from '@/types';

import { CoachMarkProps } from './types';

import styles from './styles.module.scss';

export const CoachMark: FC<CoachMarkProps> = ({
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  step,
  index,
  size,
  isLastStep,
  continuous,
}) => {
  const data = step.data as TutorialStepData | undefined;
  const segmentLabel = data?.segmentLabel;
  const segmentStepIndex = data?.segmentStepIndex;
  const segmentStepTotal = data?.segmentStepTotal;

  const counterText =
    segmentLabel && segmentStepIndex !== undefined && segmentStepTotal !== undefined
      ? `${segmentLabel} · ${segmentStepIndex + 1} / ${segmentStepTotal}`
      : `${index + 1} / ${size}`;

  const showBack = index > 0;
  const primaryLabel = continuous ? (isLastStep ? 'Finish' : 'Next') : 'Close';

  return (
    <div {...tooltipProps} className={styles.container} role="dialog" aria-modal="true">
      <div className={styles.header}>
        <span className={styles.counter}>{counterText}</span>
        <button {...closeProps} className={styles.close} aria-label="Close tutorial">
          ×
        </button>
      </div>

      {step.title && <h3 className={styles.title}>{step.title}</h3>}

      <div className={styles.body}>{step.content}</div>

      <div className={styles.footer}>
        <button {...skipProps} className={styles.skip}>
          Skip tour
        </button>

        <div className={styles.navButtons}>
          {showBack && (
            <button {...backProps} className={`${styles.btn} ${styles.btnSecondary}`}>
              Back
            </button>
          )}
          <button {...primaryProps} className={`${styles.btn} ${styles.btnPrimary}`}>
            {primaryLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
